import SuperAdminDashboardChartApi from "./SuperAdminDashboardChartApi";

const SuperAdminDashboardChartService = async (type: string): Promise<any> => {
  try {
    return await SuperAdminDashboardChartApi(type);
  } catch (error) {
    console.error("❌ Error fetching dashboard data:", error);
    throw error;
  }
};

export default SuperAdminDashboardChartService;
